import React, { useRef, useEffect } from 'react';
import get from 'lodash/get';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faFile } from '@fortawesome/free-regular-svg-icons/faFile';

import useFileUpload from '../hooks/useFileUpload';
import FileProgress from './FileProgress.jsx';

const FileInput = ({
  api,
  value,
  onChange = () => {},
  className = '',
  children,
}) => {
  const [res, req, , progress] = useFileUpload();
  const display = useRef(value);
  const isPending = res.status === 'pending';

  useEffect(() => {
    if (value instanceof File) {
      (async () => {
        display.current = { originalname: value.name };
        const { payload } = await req(api, value);

        onChange(payload);
      })();
    }
    if (value?.id && !value?._id) {
      onChange({ ...value, _id: value.id });
    }
    if (!value) display.current = value;
  }, [
    value instanceof File,
    get(value, 'name') || value,
    get(value, 'lastModified'),
  ]);

  return (
    <div className={className}>
      <div className="d-flex">
        <div className="mx-2">
          {display.current ? (
            <>
              <FA icon={faFile} className="mr-2" />
              {display.current?.originalname}
            </>
          ) : children}
        </div>
        {isPending && (
          <div className="mx-2">
            <FileProgress progress={progress} />
          </div>
        )}
        {value && (
          <div className="mx-2">
            <a
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                onChange(null);
              }}
            >
              <FA icon={faTimes} />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileInput;
